import Vue from 'vue'
// eslint-disable-next-line import/order
import { Plugin } from 'vue-fragment'

Vue.use(Plugin)
